import { render, staticRenderFns } from "./PastProjectsThree.vue?vue&type=template&id=b015179e&scoped=true"
import script from "./PastProjectsThree.vue?vue&type=script&lang=js"
export * from "./PastProjectsThree.vue?vue&type=script&lang=js"
import style0 from "./PastProjectsThree.vue?vue&type=style&index=0&id=b015179e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b015179e",
  null
  
)

export default component.exports